// extracted by mini-css-extract-plugin
module.exports = {"container":"colorfulBanner__container___23R35","wrapper":"colorfulBanner__wrapper___272XB","competitor":"colorfulBanner__competitor___3UsYs","odds":"colorfulBanner__odds___sYadS"};